var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7335_39291)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6627 21.3254C16.5516 21.3254 21.3254 16.5516 21.3254 10.6627C21.3254 4.77386 16.5516 0 10.6627 0C4.77386 0 0 4.77386 0 10.6627C0 16.5516 4.77386 21.3254 10.6627 21.3254Z",
    fill: "#C6CAD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7992 18.4002C14.9966 18.4002 18.3992 14.9976 18.3992 10.8002C18.3992 6.60283 14.9966 3.2002 10.7992 3.2002C6.60185 3.2002 3.19922 6.60283 3.19922 10.8002C3.19922 14.9976 6.60185 18.4002 10.7992 18.4002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.6598 20.0598C23.2693 19.3379 22.4409 18.9355 21.3285 18.9355C20.4882 18.9355 19.7663 19.2787 19.3403 19.8705C18.9142 20.4622 18.8196 21.2551 19.0799 22.048C19.5888 23.5864 20.4764 23.9296 20.9616 23.9888C21.0326 24.0006 21.1036 24.0006 21.1864 24.0006C21.7072 24.0006 22.5119 23.7758 23.2929 22.6042C23.9202 21.6929 24.0385 20.7817 23.6598 20.0598Z",
    fill: "#61739F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7335_39291"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch1);
export default __webpack_public_path__ + "static/media/Search1.b16cb368ad919af0b33a48c3c7c7247a.svg";
export { ForwardRef as ReactComponent };